import { chooseLanguage, language, LANGUAGES, t } from '../i18n/i18n.js';
import { el } from './dom.js';

/**
 * EN | PL in the masthead. Each language is named in itself — somebody who cannot read the
 * page is exactly who needs to find this — and choosing one reloads, as `i18n.ts` explains.
 */
export function languageSwitch(): HTMLElement {
  const group = el('div', { class: 'segmented lang-switch', id: 'lang-switch', role: 'group' });
  group.setAttribute('aria-label', t('Language'));
  for (const { code, name } of LANGUAGES) {
    const button = el(
      'button',
      { class: 'segment', type: 'button', title: name, lang: code, dataset: { lang: code } },
      code.toUpperCase(),
    );
    const on = code === language();
    button.classList.toggle('is-selected', on);
    button.setAttribute('aria-pressed', String(on));
    button.addEventListener('click', () => {
      if (code !== language()) chooseLanguage(code);
    });
    group.append(button);
  }
  return group;
}
